import styled from "@emotion/styled";
import { Backdrop } from "scmp-sdk/components/modal/backdrop";

export const PopupBackdrop = styled(Backdrop)`
  background: #000000;

  opacity: 0.5;
`;
